var map = {
	"./clams.yaml": 5362,
	"./clever.yaml": 4728,
	"./clm.yaml": 9102,
	"./clochat.yaml": 6024,
	"./dabrush.yaml": 5960,
	"./exif.yaml": 597,
	"./githru.yaml": 8080,
	"./iolens.yaml": 2622,
	"./issue_propagation.yaml": 8737,
	"./ltgm.yaml": 7599,
	"./ltnc.yaml": 7378,
	"./monetexplorer.yaml": 1824,
	"./snc.yaml": 5807,
	"./template.yaml": 994,
	"./umato.yaml": 7990,
	"./vant.yaml": 7024,
	"./vl2nl.yaml": 7052,
	"./vnli.yaml": 1895,
	"./zadu.yaml": 6801
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2625;